module.exports = __webpack_public_path__ + "static/media/pause-circle.c57a952c.svg";